import React from 'react'
import Table from '@common/Table'
import store from '../store'
import columns from './column'

export default () => {
  return <Table columns={columns} store={store} />
}
